module.exports = "/_next/static/images/br-caf2cf2c4607842d80d2b779715cc63a.svg";